;(function () {
	const menuToggle = document.querySelector( '.menu-toggle' );
	const navEl = document.querySelector( '.site-navigation' );

	if ( ! menuToggle || ! navEl ) {
		return;
	}

	menuToggle.addEventListener( 'click', e => {
		navEl.classList.toggle( 'active' );
	});


	let windowWidth = window.innerWidth;
	window.onresize = function(){
		if (windowWidth != window.innerWidth){
			navEl.classList.remove('active');
		}
	}

	const menuLinks = navEl.querySelectorAll( 'li' );
	menuLinks.forEach( ( elem, index ) => {
		elem.style.transitionDelay = `${0.2 * index * 0.35}s`;
	});
}());
